<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm" inline>
					<c-form-item type="input" label="业务员姓名" name="user_realname"></c-form-item>
					<c-form-item type="input" label="业务员手机号" name="phone"></c-form-item>
					<c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button power="b_statistic_salesman_export" @click="exportData()"  icon="export">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<c-table-column
					label="业务员姓名"
					name="user_realname"
					width ="100"
				></c-table-column>
				
				<c-table-column
					label="业务员手机号"
					name="phone"
					width ="110"
				>
				</c-table-column>
				
				<c-table-column
					label="客户数量"
					name="user_count"
					width ="110"
					sort
				>
				</c-table-column>
				
				<c-table-column
					label="下单数量"
					name="order_quantity"
					width ="90"
					sort
				>
				</c-table-column>
				
				<c-table-column
					label="下单总额"
					name="order_amount"
					width ="90"
					sort
				>
					<template v-slot="{data}">
						￥{{data.order_amount}}
					</template>
				</c-table-column>


				<c-table-column
					label="退款数量"
					name="refund_quantity"
					width ="90"
					sort
				>
				</c-table-column>

				<c-table-column
					label="退款总额"
					name="refund_amount"
					width ="90"
					sort
				>
					<template v-slot="{data}">
						￥{{data.refund_amount}}
					</template>
				</c-table-column>

			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name:'m_statistic_salesman',
		
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/salesman/list',
					data
				});
			},
			exportData(){
				var exportData = this.$refs.searchForm.serialize();
				exportData.job_id = 29;
				exportData.create_system = 'OMS';
				
				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>